import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AdminAuthService } from 'src/app/shared/services/auth.service';


@Injectable({ providedIn: 'root' })
export class RolesGuard  {
    public appNamePermissions = new AppNamePermissionsReturnModel();

    constructor(
        private router: Router,
        private adminAuthService: AdminAuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.adminAuthService.isLoggedIn()) {
            const appRole: string = route.data['appRole'];
            let roleFound: boolean = this.adminAuthService.hasUserRole(appRole);

            if (roleFound) {
                return true;
            } else {
                // user does not have this role so redirect to unauthorized page.
                this.router.navigate(['/unauthorized']);
            }

        }
        return false;
    }
}

export class AppNamePermissionsReturnModel {
  constructor() {
    this.appName = '';
    this.permission = '';
  }

  public appName: string;
  public permission: string;
}
